import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';



export class ProjectKeyInformationView extends Component {

	render() {
		const { sector, smcsCode } = this.props;
		return (
			<Card>
				<CardHeader title="Project Key Information" className='romis-card-header' />
				<CardContent>
					<TextField
						label="Sector :"
						//value="Sector"
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}
						value={sector}

					/>

					<TextField
						label="SMCS Code :"
						//value="SMCS Code"
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}
						value={smcsCode}

					/>

				</CardContent>

			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/ProjectKeyInformationView.js